import { ofType } from 'redux-observable'
import { mergeMap, tap } from 'rxjs/operators'
import { tag } from 'rxjs-spy/operators'
import { userApiEvents } from '../../api/user'
import { ROUTES } from 'constants/routes'
import { events } from './state'

/**
 * Close the switcher modal, then hard-navigate to the dashboard so the whole app
 * boots on the new agency. A plain reload kept the current URL, which can belong
 * to the previous agency (a contact, lease or invoice id). setJwtTokens has
 * already persisted the new token pair by the time this runs.
 */
export const refreshOnAgencySwitch = (action$: any, state$: any) =>
  action$.pipe(
    ofType(userApiEvents.switchAgency_success),
    mergeMap(() => [events.close()]),
    tap(() => window.location.assign(ROUTES.dashboard)),
    tag('agencySwitcher/epic/refreshOnAgencySwitch'),
  )
